import { createSlice } from "@reduxjs/toolkit";
// import kpiService from '@services/kpi.service';

const initialState = {
  data: [],
  // status: 'idle',
  error: null,
};

// export const fetchKpiAsync = createAsyncThunk(
//   'pms/fetchKpis',
//   async () => {
//     const response = await kpiService.fetchKpi();
//     return response.data;
//   }
// );

export const pmSlice = createSlice({
  name: "pms",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    addCounter: (state, action) => {
      state.data = [...state.data, action.payload];
    },
    hideCounter: (state, action) => {
      state.data = state.data.reduce((result, item) => {
        if (item.id === action.payload) {
          item.show = !item.show;
        }
        result.push(item);

        return result;
      }, []);
    },
    hideCounters: (state, action) => {
      state.data = state.data.reduce((result, item) => {
        if (item.id === action.payload) {
          item.counterShow = !item.counterShow;
        }
        result.push(item);

        return result;
      }, []);
    },
    axisAlignCounter: (state, action) => {
      const { id, align, type } = action.payload;
      state.data = state.data.reduce((result, item) => {
        if (item.id === id) {
          item.align[type] = align;
        }
        result.push(item);

        return result;
      }, []);
    },
    updateCounterChartType: (state, action) => {
      const { id, type } = action.payload;
      state.data = state.data.reduce((result, item) => {
        if (item.id === id) {
          item.type = type;
        }
        result.push(item);

        return result;
      }, []);
    },
    changeCounterColor: (state, action) => {
      const { id, color } = action.payload;
      state.data = state.data.reduce((result, item) => {
        if (item.id === id) {
          item.color = color;
        }

        result.push(item);

        return result;
      }, []);
    },
    removeCounter: (state, action) => {
      state.data = state.data.filter((x) => x.id !== action.payload);
    },
    clearCounters: (state) => {
      state.data = [];
    },
  },

  // extraReducers: (builder) => {
  //   builder
  //     .addCase(fetchKpiAsync.pending, (state) => {
  //       state.status = 'loading';
  //     })
  //     .addCase(fetchKpiAsync.fulfilled, (state, action) => {
  //       state.status = 'idle';
  //       state.data = [...action.payload];
  //     })
  //     .addCase(fetchKpiAsync.rejected, (state, action) => {
  //       state.status = 'rejected';
  //       state.error = action.payload;
  //     });
  // },
});

export const {
  addCounter,
  hideCounter,
  hideCounters,
  removeCounter,
  axisAlignCounter,
  changeCounterColor,
  updateCounterChartType,
  clearCounters,
} = pmSlice.actions;

export default pmSlice.reducer;
